import { useAppSelector } from 'app/hooks';
import { useMemo } from 'react';
import { deriveHybridDuctedSpaceIds } from 'utils/hybrid-config-autobuild';

export default function useHybridLeftoverSpaceIds(): Set<string> {
  const { structure, autoLayoutSpaceIds } = useAppSelector(
    (state) => state.structure
  );
  return useMemo(() => {
    if (!Array.isArray(structure)) return new Set();
    return new Set(
      deriveHybridDuctedSpaceIds(structure, autoLayoutSpaceIds ?? [])
    );
  }, [structure, autoLayoutSpaceIds]);
}
